export default "__VITE_ASSET__osoFEsxV__"